import Vue from "vue";

// Reglas de categorías por cuenta contable (cuentas con categoría obligatoria).
// Se comparte entre pantallas para no consultarlas en cada una.
const state = Vue.observable({ rules: {}, loaded: false });
let loading = null;

export default {
  created() {
    this.loadAccountCategoryRules();
  },

  methods: {
    async loadAccountCategoryRules(force = false) {
      if (state.loaded && !force) return;
      if (loading && !force) return loading;

      loading = (async () => {
        try {
          const response = await this.api_Get("accounting/account_category_rules");
          const data = await response.json();
          const rules = {};
          (Array.isArray(data) ? data : []).forEach((row) => {
            rules[row.chart_of_account_id] = {
              categories: row.allowed_category_ids || [],
              subcategories: row.allowed_subcategory_ids || [],
            };
          });
          state.rules = rules;
          state.loaded = true;
        } catch (error) {
          console.error("Error cargando reglas de categorías por cuenta", error);
        } finally {
          loading = null;
        }
      })();
      return loading;
    },

    // Regla de la cuenta o null si la cuenta no tiene categoría obligatoria
    accountCategoryRule(accountId) {
      if (accountId === null || accountId === undefined) return null;
      const id = typeof accountId === "object" ? accountId.id ?? accountId.value : accountId;
      return state.rules[id] || null;
    },

    // Categorías raíz que se pueden usar con la cuenta
    categoriesForAccount(categories, accountId) {
      const roots = (categories || []).filter((c) => c.parent_id === null);
      const rule = this.accountCategoryRule(accountId);
      if (!rule || rule.categories.length === 0) return roots;
      return roots.filter((c) => rule.categories.includes(c.id));
    },

    // Subcategorías de la categoría que se pueden usar con la cuenta
    subcategoriesForAccount(categories, accountId, categoryId) {
      if (categoryId === null || categoryId === undefined) return [];
      const children = (categories || []).filter((c) => c.parent_id === categoryId);
      const rule = this.accountCategoryRule(accountId);
      if (!rule) return children;
      const restricted = children.filter((c) => rule.subcategories.includes(c.id));
      return restricted.length > 0 ? restricted : children;
    },

    // Devuelve el mensaje de error o null si la combinación es válida
    accountCategoryError(categories, accountId, categoryId, subcategoryId, accountLabel = "") {
      const rule = this.accountCategoryRule(accountId);
      if (!rule) return null;
      const label = accountLabel ? ` ${accountLabel}` : "";

      if (categoryId === null || categoryId === undefined || categoryId === "") {
        return `La cuenta${label} requiere categoría`;
      }
      if (!this.categoriesForAccount(categories, accountId).some((c) => c.id === categoryId)) {
        return `La categoría seleccionada no está permitida para la cuenta${label}`;
      }

      const allowedSubs = this.subcategoriesForAccount(categories, accountId, categoryId);
      if (allowedSubs.length > 0) {
        if (subcategoryId === null || subcategoryId === undefined || subcategoryId === "") {
          return `La cuenta${label} requiere subcategoría`;
        }
        if (!allowedSubs.some((c) => c.id === subcategoryId)) {
          return `La subcategoría seleccionada no está permitida para la cuenta${label}`;
        }
      }
      return null;
    },

    // Limpia categoría/subcategoría que ya no aplican tras cambiar la cuenta
    resetInvalidAccountCategory(target, categories, accountId, categoryKey, subcategoryKey) {
      if (!target) return;
      const allowed = this.categoriesForAccount(categories, accountId);
      if (target[categoryKey] != null && !allowed.some((c) => c.id === target[categoryKey])) {
        this.$set(target, categoryKey, null);
        this.$set(target, subcategoryKey, null);
        return;
      }
      if (target[subcategoryKey] != null) {
        const subs = this.subcategoriesForAccount(categories, accountId, target[categoryKey]);
        if (!subs.some((c) => c.id === target[subcategoryKey])) {
          this.$set(target, subcategoryKey, null);
        }
      }
    },
  },
};
